import { Component, ErrorHandler, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute } from '@angular/router'

import { LadataanService } from '../../_jaettu-angular/service/ladataan.service'

import { EnableBankingAuthoriseSessionRequest, EnableBankingOauthAuthoriseSessionResponse } from '@lemon/core-firebase/model/enable-banking-shared'
import { AllowedDialogsService } from 'app/_angular/service/allowed-dialogs.service'
import { EnableBankingDialogService } from 'app/_angular/service/enable-banking-dialog.service'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { KayttajaService } from 'app/_angular/service/kayttaja.service'
import { EnableBankingLoginCompletedDialog } from 'app/banks/enable-banking/enable-banking-login-completed.dialog'
import { EnableBankingLoginFailedDialog } from 'app/banks/enable-banking/enable-banking-login-failed.dialog'

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EnableBankingOauthCallbackComponent {
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _errorHandler: ErrorHandler,
    private _ladataanService: LadataanService,
    private _dialog: MatDialog,
    private _allowedDialogsService: AllowedDialogsService,
    private _kayttajaService: KayttajaService,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _enableBankingDialogService: EnableBankingDialogService,
  ) {
    this._allowedDialogsService.disableAllDialogs()
    this._ladataanService.aloitaLataaminen()
    this._enableBankingDialogService.setFlowCompleted()

    const state = this._activatedRoute.snapshot.queryParamMap.get('state')
    const code = this._activatedRoute.snapshot.queryParamMap.get('code')
    const error = this._activatedRoute.snapshot.queryParamMap.get('error')

    if (code && !error) {
      const req: EnableBankingAuthoriseSessionRequest = {
        code: code,
        userAgent: navigator?.userAgent || null,
      }

      this._firebaseLemonaid
        .functionsCall<EnableBankingAuthoriseSessionRequest, EnableBankingOauthAuthoriseSessionResponse>('enableBankingAuthoriseSession', req)
        .then(vastaus => {
          const err = vastaus.e
          this._ladataanService.lopetaLataaminen()
          if (err) {
            this._writeLoginFailToLog(error)
            this._errorHandler.handleError(new Error(error ?? 'Enable Banking authorization failed'))
            this._dialog.open(EnableBankingLoginFailedDialog)
          } else {
            this._dialog.open(EnableBankingLoginCompletedDialog)
          }
        })
        .catch(err => {
          this._ladataanService.lopetaLataaminen()
          this._errorHandler.handleError(err)
          this._writeLoginFailToLog(err ? JSON.stringify(err) : 'unknown-error')
          this._dialog.open(EnableBankingLoginFailedDialog)
        })
    } else {
      this._ladataanService.lopetaLataaminen()
      this._writeLoginFailToLog(error ?? 'Missing code')
      this._errorHandler.handleError(new Error(error ?? 'Missing code'))
      this._dialog.open(EnableBankingLoginFailedDialog)
    }
  }

  private _writeLoginFailToLog(reason: string) {
    return this._kayttajaService
      .getKayttaja()
      .then(kayttaja => {
        return this._enableBankingDialogService.saveHistory(kayttaja?.asiakasAvain, 'Paluu Enable Banking -valtuutuksesta epäonnistui', reason)
      })
      .catch(err => {
        this._errorHandler.handleError(new Error('Enable Banking log save failed ' + err?.message || ''))
      })
  }
}
